import React, { useState, useEffect } from "react";
import DiscrepancyModal from "./DiscrepancyModal";
import { CiCircleCheck } from "react-icons/ci";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../loader/Loader";

const ShiftChange = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [totalproduction, setTtotalproduction] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    fetchtotalproduction();
  }, []);

  const fetchtotalproduction = async () => {
    const token = getAuthToken();

    if (!token) {
      return;
    }

    try {
      setLoading(true);

      const response = await axios.get(
        `${config.API}/operator/totalproduction`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data;
      setTtotalproduction(data);
    } catch (err) {
      console.error(
        "Error fetching orders:",
        err.message
      );

      setTtotalproduction([]);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // LOGOUT USER
  // =========================
  const logoutUser = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    navigate("/", {
      replace: true,
    });
  };

  // =========================
  // ACCEPT SUMMARY
  // =========================
  const handleSubmit = async () => {
    const token = getAuthToken();

    if (!token) {
      toast.error("Authentication token missing!");
      logoutUser();
      return;
    }

    try {
      const response = await axios.post(
        `${config.API}/operator/acceptsummary`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { success, message } = response.data;

      if (success === true) {
        toast.success(
          message ||
            "Request submitted successfully!"
        );

        // Logout after accepting summary
        logoutUser();

        return;
      }

      toast.error(
        message || "Something went wrong!"
      );
    } catch (err) {
      console.error("Error:", err);

      // JWT expired / invalidated
      if (err.response?.status === 401) {
        logoutUser();

        toast.error(
          err.response?.data?.message ||
            "Your session has expired. Please login again."
        );

        return;
      }

      toast.error(
        err.response?.data?.message ||
          "Failed to submit material issue request!"
      );
    }
  };

  return (
    <div className="container my-4">
      <div className="row justify-content-center font_family">
        <div className="col-lg-8">
          <div className="card p-4 shadow-sm endShift">
            {loading ? (
              <Loader />
            ) : (
              <>
                <header className="d-flex justify-content-between align-items-start mb-4">
                  <div>
                    <h5 className="fw-bold mb-1 font_shift">
                      End of Shift Summary
                    </h5>

                    <p className="mb-0 text-muted">
                      Date:{" "}
                      {new Date().toLocaleDateString(
                        "en-GB"
                      )}
                    </p>

                    <p className="mb-0 text-muted">
                      Shift: Morning
                    </p>
                  </div>

                  <div className="text-end">
                    <h5 className="fw-semibold mb-0">
                      {parseFloat(
                        totalproduction?.productivity ||
                          0
                      ).toFixed(2)}
                      %
                    </h5>

                    <small className="text-muted">
                      Efficiency
                    </small>
                  </div>
                </header>

                <div className="mb-4 production_summary">
                  <h6 className="fw-semibold">
                    Production Summary |{" "}
                    {totalproduction?.product}
                  </h6>

                  <div className="text-end">
                    <small>
                      {totalproduction?.total_production}{" "}
                      /{" "}
                      {totalproduction?.daily_target}
                    </small>
                  </div>

                  <div
                    className="progress mb-3"
                    style={{ height: "6px" }}
                  >
                    <div
                      className="progress-bar bg-primary"
                      role="progressbar"
                      style={{
                        width: `${
                          totalproduction?.daily_target >
                          0
                            ? (totalproduction?.total_production /
                                totalproduction?.daily_target) *
                              100
                            : 0
                        }%`,
                      }}
                      aria-valuenow={
                        totalproduction?.total_production
                      }
                      aria-valuemin="0"
                      aria-valuemax={
                        totalproduction?.daily_target
                      }
                    />
                  </div>

                  <div className="row g-3 text-center">
                    <div className="col-md-4 endShiftBox">
                      <div className="card bg-light p-3 h-100 border-0">
                        <h5 className="fw-bold mb-0">
                          {
                            totalproduction?.total_production
                          }
                        </h5>

                        <small className="text-muted">
                          Units Produced
                        </small>
                      </div>
                    </div>

                    <div className="col-md-4 endShiftBox">
                      <div className="card bg-light p-3 h-100 border-0">
                        <h5 className="fw-bold mb-0">
                          {totalproduction?.daily_target}
                        </h5>

                        <small className="text-muted">
                          Target Units
                        </small>
                      </div>
                    </div>

                    <div className="col-md-4 endShiftBox">
                      <div className="card bg-light p-3 h-100 border-0">
                        <h5 className="fw-bold mb-0">
                          {totalproduction?.total_nc}
                        </h5>

                        <small className="text-muted">
                          Non-Conformities
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row g-3 btn-row">
                  <div className="col-12 col-lg-6">
                    <button
                      className="btn btn-outline-secondary w-100 h-100"
                      onClick={() =>
                        setShowModal(true)
                      }
                    >
                      <AiOutlineExclamationCircle />{" "}
                      Report Discrepancy
                    </button>

                    <DiscrepancyModal
                      show={showModal}
                      handleClose={() =>
                        setShowModal(false)
                      }
                    />
                  </div>

                  <div className="col-12 col-lg-6">
                    <button
                      className="btn btn-primary w-100 h-100"
                      onClick={handleSubmit}
                    >
                      <CiCircleCheck /> Accept Summary
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShiftChange;